exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "thead{background-color:#78b943}thead th,thead th i{color:#fff!important}.v-pagination{-ms-flex-wrap:wrap;flex-wrap:wrap}.v-data-table td,.v-data-table th{padding:0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e8fb0ec","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/actors/index.vue
// module id = ZlgM
// module chunks = 1